import { render, staticRenderFns } from "./InquiryQuickReview.vue?vue&type=template&id=56ca2675&scoped=true&"
import script from "./InquiryQuickReview.vue?vue&type=script&lang=js&"
export * from "./InquiryQuickReview.vue?vue&type=script&lang=js&"
import style0 from "./InquiryQuickReview.vue?vue&type=style&index=0&id=56ca2675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ca2675",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDivider,VRow})
